var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSlot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 2.66669C8.6373 2.66669 2.66797 8.63602 2.66797 16C2.66797 23.364 8.6373 29.3334 16.0013 29.3334C23.3653 29.3334 29.3346 23.364 29.3346 16C29.3346 8.63602 23.3653 2.66669 16.0013 2.66669ZM22.668 17.3334H17.3346V22.6667H14.668V17.3334H9.33464V14.6667H14.668V9.33335H17.3346V14.6667H22.668V17.3334Z",
    fill: "var(--tertiary-icon-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSlot);
export default __webpack_public_path__ + "static/media/addSlot.bf5de505c8d9717273657b15d394409c.svg";
export { ForwardRef as ReactComponent };